export default "/static/webpack/images/about/sallybennett.jpg";